import { Link } from "react-router-dom";

import Stack from "react-bootstrap/Stack";
import Card from "react-bootstrap/Card";
import Badge from "react-bootstrap/Badge";

import {
  formatCurrency,
  formatNumber,
  formatDateTime,
  getTimezoneDate,
  getSinglarOrPluralWord,
  timezones,
  globalStatuses,
} from "../../../../utilities/helpers";

import { TrashButton } from "../../../TrashButton";

import placeholder from "../../../../assets/placeholder.png";

export default function FlexPack({ flexPack, openDeleteModal }) {
  const timezone = timezones(flexPack?.venue?.timezone);

  const getStatus = (s) => {
    let status = s;
    // if hidden and has not ended
    if (!flexPack?.is_visible && flexPack?.status !== "complete") {
      status = "hidden";
    }
    // if sold out and has not ended
    else if (flexPack?.is_sold_out && flexPack?.status !== "complete") {
      status = "sold_out";
    }
    return globalStatuses[status];
  };

  return (
    <Card className="card--sm">
      <Card.Body className="flex gap-3">
        <Link to={`/flex-package/${flexPack?.uuid}`} className="flex-grow-1">
          <Stack direction="horizontal" gap={3}>
            <Card.Img
              src={flexPack?.image?.url || placeholder}
              width="80"
              height="80"
              className="event-image card-img-sm"
              alt={`Cover art for ${flexPack?.name} flex package`}
            />
            <Stack className="justify-content-around">
              <Card.Title as="h5">{flexPack?.name}</Card.Title>
              <Card.Subtitle
                as="h6"
                className="m-0 subtitle-bolder subtitle--dark"
              >
                {flexPack?.organization?.name} - {flexPack?.season?.name}
              </Card.Subtitle>
              <Card.Text className="text-muted small">
                <span>
                  <span>
                    {formatDateTime(
                      getTimezoneDate(flexPack.start, timezone),
                      "dateOnly",
                    )}
                  </span>
                  <span className="time">
                    {formatDateTime(
                      getTimezoneDate(flexPack.start, timezone),
                      "timeOnly",
                    )}
                  </span>
                </span>
                <span className="to">
                  <span>
                    {formatDateTime(
                      getTimezoneDate(flexPack?.end, timezone),
                      "dateOnly",
                    )}
                  </span>
                  <span className="time">
                    {formatDateTime(
                      getTimezoneDate(flexPack?.end, timezone),
                      "timeOnly",
                    )}
                  </span>
                </span>
              </Card.Text>
            </Stack>
          </Stack>
        </Link>
        <Stack direction="horizontal" gap={3} className="ms-auto">
          <Badge bg="none" className="badge-label">
            {formatCurrency(flexPack?.price)}
          </Badge>
          <Badge bg="none" className="badge-label">
            {formatNumber(flexPack?.game_tickets)}{" "}
            {getSinglarOrPluralWord(flexPack?.game_tickets, "Voucher")}
          </Badge>
          <Badge
            bg="none"
            className={`badge--${getStatus(flexPack?.status)?.type}`}
          >
            {getStatus(flexPack?.status)?.label}
          </Badge>
          <TrashButton
            variant="danger"
            onClick={(e) => openDeleteModal(e, flexPack?.id)}
            isDisabled={flexPack?.isSold}
          />
        </Stack>
      </Card.Body>
    </Card>
  );
}
